<script lang="ts">
	import vivenuS04 from './svg/vivenu-s04.svg';
	import { _ } from 'svelte-i18n';

	const year = new Date().getFullYear();
</script>

<section>
	<div />
	<a href="#top" title={$_('components.footer.scrollTopText')}>
		<img
			src={vivenuS04}
			alt="Schalke 04 Logo und Vivenu Logo"
			loading="lazy"
			width="363"
			height="150"
		/>
	</a>
	<small>&copy; {year} {$_('page.brand.shortName')}</small>
</section>

<style>
	section {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	small {
		padding-top: 1rem;
	}
</style>
